import { Box, Paper } from '@chronosphereio/chrono-ui';
import { useFeatureFlags } from '@chronosphereio/core';
import React from 'react';
import { RouteConstants } from '@/model/Routes';
import { ChronosphereBanner, ChronospherePANWBanner } from '../styles';
import { Link } from './Link';

export interface LogoPaneProps {
  children?: React.ReactNode;
}

/**
 * Template component that shows a full width/height pane with our logo and a
 * centered Paper below it.
 */
export function LogoPane(props: LogoPaneProps) {
  const { children } = props;
  const { enableNewLogoStubYear } = useFeatureFlags();

  return (
    <Box
      sx={{
        width: '100%',
        height: '100%',
        overflowY: 'auto',
        display: 'flex',
        flexFlow: 'column nowrap',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Link to={RouteConstants.HOME} sx={{ width: 300 }}>
        {enableNewLogoStubYear ? <ChronospherePANWBanner /> : <ChronosphereBanner />}
      </Link>

      <Paper
        sx={(theme) => ({
          width: '100%',
          padding: theme.spacing(4, 2),

          [theme.breakpoints.up('sm')]: {
            maxWidth: 500,
          },
        })}
      >
        {children}
      </Paper>
    </Box>
  );
}
